import Vuex from 'vuex';
import Vue from 'vue';
import auth from './modules/auth';
import agentProfile from './modules/agentProfile';
import onboarding from './modules/onboarding';
import cachestore from './modules/cachestore';
import distroCenter from './modules/distroCenter';
import fulfillments from './modules/fulfillments';
import role from './modules/role';
import generic from './modules/generic';
import purchaseOrder from './modules/purchaseOrder';
import shipments from './modules/shipments';
import invoices from './modules/invoices'
import payments from './modules/payments'
import vaccineTemplate from './modules/vaccineTemplate';
import breeds from './modules/breeds';
import pipeline from './modules/pipeline';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth,
		agentProfile,
		onboarding,
		cachestore,
		distroCenter,
		fulfillments,
		role,
		generic,
		purchaseOrder,
		shipments,
		invoices,
		payments,
		vaccineTemplate,
		breeds,
		pipeline,
	},
});
